import { render } from "./UserStoryDetailDialog.vue?vue&type=template&id=2ecb121d&scoped=true"
import script from "./UserStoryDetailDialog.vue?vue&type=script&lang=js"
export * from "./UserStoryDetailDialog.vue?vue&type=script&lang=js"

import "./UserStoryDetailDialog.vue?vue&type=style&index=0&id=2ecb121d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecb121d"]])

export default __exports__